import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'credit-account-alert',
    templateUrl: './credit-account-alert.component.html',
    styleUrls: ['./credit-account-alert.component.scss'],
    standalone: false
})
export class CreditAccountAlertComponent implements OnInit {
  @Input() isOrgAdminUser: boolean;

  public alertText: string;

  constructor() {}

  ngOnInit(): void {
      if (this.isOrgAdminUser) {
          this.alertText = 'Your account is running low on credits! Go to the Billing page under Organization Settings to see details on your upcoming billing cycle or purchase additional credits.';
      } else {
          this.alertText = 'Your account is running low on credits! Contact your Organization Admin to add more credits to your account.';
      }
  }
}
